import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import("./views/dashboard.vue")
        }
    ];
};